import { module as modu } from 'modujs'
import Lenis from 'lenis'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class extends modu {
  constructor(m) {
    super(m)
  }

  init() {
    const sibling = this.el.nextElementSibling

    const button = this.el.querySelector('[data-next]')
    button?.addEventListener('click', () => {
      // console.log(window.headerOffset)
      window.lenis.scrollTo(sibling, { offset: -window.headerOffset })
    })
  }
}
